import { Divider, Grid2, Typography } from "@mui/material";

type P = {
  contentIcon: JSX.Element;
  contentTitle: string;
  contents: Array<string>;
  contentInfo?: JSX.Element;
  contentChildren?: JSX.Element;
};

export const ScheduleContentList: React.FC<P> = ({
  contentIcon,
  contentTitle,
  contents,
  contentInfo,
  contentChildren
}) => {
  return (
    <Grid2 size={{ xs: 12 }} container data-testid={`${contentTitle}-content-list-grid`}>
      {/* content list header */}
      <Grid2
        size={{ xs: 12 }}
        display={"flex"}
        alignItems={"center"}
        data-testid={`${contentTitle}-content-list-grid-header-item`}
      >
        {contentIcon}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", ml: 1.5 }}>
          {contentTitle}
        </Typography>
        {contentInfo}
      </Grid2>

      {/* content list items */}
      {contents.length > 0 && (
        <Grid2
          size={{ xs: 12 }}
          sx={{ pl: 4, mt: 2 }}
          data-testid={`${contentTitle}-content-list-grid-list-item`}
        >
          {contents.map(content => (
            <Typography key={content}>{content}</Typography>
          ))}
        </Grid2>
      )}

      {contentChildren && (
        <Grid2
          size={{ xs: 12 }}
          sx={{ pl: 4, mt: 2 }}
          data-testid={`${contentTitle}-content-list-grid-item-children`}
        >
          {contentChildren}
        </Grid2>
      )}

      <Divider
        orientation={"horizontal"}
        color={"#aaa"}
        variant={"fullWidth"}
        sx={{ width: "100%", mt: 2, opacity: "0.6" }}
      />
    </Grid2>
  );
};
